export default __webpack_public_path__ + "static/media/admin_product_edit_icon.20777fe6.svg";